"use client";

import { Loader2 } from "lucide-react";
import Modal from "@/app/components/ui/Modal";
import { WorkspaceSelectList } from "@/app/components/WorkspaceSelectList";
import { Workspace } from "@/lib/api";

type WorkspaceSelectModalProps = {
    isOpen: boolean;
    onClose: () => void;
    workspaces: Workspace[];
    selectedWorkspaceId?: string | null;
    onSelect: (workspaceId: string) => void;
    isLoading?: boolean;
    isSubmitting?: boolean;
    title?: string;
};

export function WorkspaceSelectModal({
    isOpen,
    onClose,
    workspaces,
    selectedWorkspaceId,
    onSelect,
    isLoading = false,
    isSubmitting = false,
    title = "เลือกเวิร์กสเปซ",
}: WorkspaceSelectModalProps) {
    const listLoading = isLoading && !isSubmitting;

    return (
        <Modal
            isOpen={isOpen}
            onClose={isSubmitting ? () => {} : onClose}
            title={title}
            size="sm"
            preventBackdropClose={isSubmitting}
            hideCloseButton={isSubmitting}
        >
            <div className="relative">
                {isSubmitting ? (
                    <div
                        className="absolute inset-0 z-10 flex flex-col items-center justify-center gap-2 rounded-lg bg-aera-white/90 backdrop-blur-[2px]"
                        role="status"
                        aria-live="polite"
                    >
                        <Loader2
                            className="h-7 w-7 animate-spin text-aera-amber"
                            aria-hidden
                        />
                        <p className="text-sm font-medium text-aera-charcoal">
                            กำลังเปิดร้าน…
                        </p>
                    </div>
                ) : null}
                <WorkspaceSelectList
                    workspaces={workspaces}
                    selectedWorkspaceId={selectedWorkspaceId}
                    onSelect={onSelect}
                    isLoading={listLoading}
                    disabled={isSubmitting}
                />
            </div>
        </Modal>
    );
}
